import { IForecastRepository } from '@domain/forecast/IForecastRepository';
import { Forecast, ForecastSourceType } from '@domain/forecast/models/Forecast';
import { Resource } from '@domain/base/Resource';
import { ForecastDataSource } from '../datasources/ForecastDataSource';
import { WeeklyForecast } from '@domain/forecast/models/WeeklyForecast';
import { ForecastRun } from '@domain/forecast/models/ForecastRun';

export class ForecastRepository implements IForecastRepository {
  constructor(private dataSource: ForecastDataSource) { }

  async getLatestForecast(sourceType: ForecastSourceType, source?: string, connector?: string): Promise<Resource<Forecast>> {
    try {
      const data = await this.dataSource.getLatestForecast(sourceType, source, connector);
      return {
        status: 'success',
        data: data
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch latest forecast'
        }
      };
    }
  }

  async getAggregatedForecast(): Promise<Resource<Omit<WeeklyForecast, 'forecastId'>[]>> {
    try {
      const data = await this.dataSource.getAggregatedForecast();
      return {
        status: 'success',
        data: data
      };
    } catch (error) {
      return {
        status: 'error',
        error: {
          type: 'UnknownError',
          message: 'Failed to fetch aggregated forecast'
        }
      };
    }
  }

  async runProductForecast(productId: string): Promise<Resource<ForecastRun>> {
    try {
      const forecastRun = await this.dataSource.runProductForecast(productId);
      return { status: 'success', data: forecastRun };
    } catch (error) {
      return { status: 'error', error: { type: 'UnknownError', message: 'Failed to run product forecast' } };
    }
  }

  async getProductRuns(productId: string): Promise<Resource<ForecastRun[]>> {
    try {
      const forecastRuns = await this.dataSource.getProductRuns(productId);
      return { status: 'success', data: forecastRuns };
    } catch (error) {
      return { status: 'error', error: { type: 'UnknownError', message: 'Failed to get product runs' } };
    }
  }
}

